export default __webpack_public_path__ + "static/media/Mail_white.f97f103f.svg";